import { Button } from '@library/components/buttons';
import { DateTime } from 'luxon';
import type { LeagueGames } from '@library/types/games';
import { Loading } from '@library/components/Loading';
import { NoData } from '@library/components/NoData';
import { classNames } from '@library/utils';
import { formatWithTimezoneChange } from '@library/utils/dateTime';

export interface GamePickerProps {
  games: LeagueGames;
  isError: boolean;
  isLoading: boolean;
  selectGame: (gameId: string) => void;
  selectedGame: string;
}

export const GamePicker = ({
  games,
  isError,
  isLoading,
  selectGame,
  selectedGame
}: GamePickerProps) => {
  const gameList = games.map((game) => {
    const gameTime = formatWithTimezoneChange(
      DateTime.fromISO(game.date_time),
      'ccc t ZZZZ'
    );

    const tagline = `${game.away_team} vs. ${game.home_team}`;

    const isGameSelected = selectedGame === game.game_id;

    return (
      <Button
        className={classNames(
          'mb-1 flex h-16 min-w-fit flex-col rounded-md p-4',
          isGameSelected ? 'bg-soClean-100' : 'bg-soFresh-120'
        )}
        onClick={() => selectGame(game.game_id)}
        key={game.game_id}
      >
        <span
          className={classNames(
            'text-xs',
            isGameSelected ? 'text-soFresh-130' : 'text-soClean-180'
          )}
        >
          {gameTime}
        </span>
        <span
          className={classNames(
            'text-sm font-bold',
            isGameSelected ? 'text-soFresh-120' : 'text-soClean-100'
          )}
        >
          {tagline}
        </span>
      </Button>
    );
  });

  if (isLoading) {
    return (
      <Loading
        loadingMessage="Loading Games"
        className="!py-1"
        messageClassName="!pt-1"
      />
    );
  }

  if (isError) {
    return <NoData />;
  }

  return (
    <div className="flex gap-4 overflow-y-hidden overflow-x-scroll overscroll-x-none">
      {gameList}
    </div>
  );
};
